import { StyledBiennale } from 'components'
import { useThemeMediaQuery } from 'hooks/useThemeMediaQuery'
import MainWrapper from 'layouts/MainWrapper'
import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, TextVariant, Text } from '@mprolab/uikit'
import Image from 'components/CompatImage'
import { Grid } from '@mui/material'
import { tokenomicsConfig, tokenomicsBaseConfig } from 'config'
import TokenomicsImage from '../../public/images/tokenomics.webp'
import GradientImage from '../../public/images/mproGradient.webp'
import PercentageCell from './components/PercentageCell'

const Wrapper = styled(Flex)`
  width: 100%;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 140px 0;
  ${({ theme }) => theme.mediaQueries.tablet} {
    padding: 120px 0;
  }
`

const StyledDescription = styled(Text)`
  white-space: pre-wrap;
`

const StyledText = styled(Text)`
  font-size: 24px;
`

const GradientWrapper = styled(Flex)<{ opositeGradient?: boolean }>`
  position: absolute;
  right: ${({ opositeGradient }) => (opositeGradient ? '0px' : '-200px')};
  left: ${({ opositeGradient }) => (opositeGradient ? '-30px' : '0px')};
  top: ${({ opositeGradient }) => (opositeGradient ? '200px' : '-200px')};
  z-index: -1;
`

/** Home Tokenomics section — numbers and rows from `config/tokenomics-section.ts` (static, not Contentful). */
const Tokenomics: React.FC = () => {
  const { colors } = useTheme()
  const isTablet = useThemeMediaQuery('tablet')
  const isMobile = useThemeMediaQuery('mobile')
  const isSmallDesktop = useThemeMediaQuery('xl')
  const { supply, communityReward, percentage } = tokenomicsBaseConfig
  return (
    <MainWrapper>
      <Wrapper>
        <StyledBiennale variant={isMobile ? TextVariant.H4 : TextVariant.H2}>Tokenomics</StyledBiennale>
        <Flex alignItems="center" gap="4px" flexDirection={isMobile ? 'column' : 'initial'}>
          <StyledText>Supply fixed at</StyledText>
          <Text variant={TextVariant.H5}>{`${supply} MPRO`}</Text>
        </Flex>
        <Flex
          gap={isTablet ? '64px' : '5vw'}
          mt={isSmallDesktop ? '64px' : '40px'}
          flexDirection={isTablet ? 'column' : 'initial'}
        >
          <Flex fullWidth position="relative">
            <Image src={TokenomicsImage} objectFit="contain" />
            <GradientWrapper opositeGradient>
              <Image src={GradientImage} />
            </GradientWrapper>
            <GradientWrapper>
              <Image src={GradientImage} />
            </GradientWrapper>
          </Flex>
          <Flex flexDirection="column" fullWidth>
            <Flex fullWidth flexDirection="column" gap="8px">
              <Flex gap="8px">
                <Text variant={TextVariant.H5}>{`Community Reward - ${communityReward}`}</Text>
                <PercentageCell {...{ percentage }} />
              </Flex>
              <Text color={colors.gray3}>Daily distribution</Text>
            </Flex>
            <Grid container rowGap={isSmallDesktop ? 4 : 2} columnSpacing={2} mt="24px">
              {tokenomicsConfig.map((item, index) => {
                const { title, amount, description, percentage } = item
                return (
                  <Grid item xs={12} sm={6} md={6} maxWidth="285px" key={index}>
                    <Flex flexDirection="column">
                      <Flex gap="8px">
                        <Text variant={TextVariant.H5} style={{ wordBreak: 'keep-all' }}>
                          {amount}
                        </Text>
                        <PercentageCell {...{ percentage }} />
                      </Flex>
                      <Text variant={TextVariant.BODY_DEFAULT_BOLD} color={colors.gray3}>
                        {title}
                      </Text>
                      <StyledDescription mt="8px" variant={TextVariant.BODY_SMALL} color={colors.gray3}>
                        {description}
                      </StyledDescription>
                    </Flex>
                  </Grid>
                )
              })}
            </Grid>
          </Flex>
        </Flex>
      </Wrapper>
    </MainWrapper>
  )
}

export default Tokenomics
